import { Link } from "react-router-dom";
import { ArrowRight, type LucideIcon } from "lucide-react";

export type Service = {
  badge: string;
  icon: LucideIcon;
  title: string;
  body: string;
  price: string;
  cta: { label: string; to: string };
};

export default function ServiceCards({ services, columns = 3 }: { services: Service[]; columns?: 2 | 3 }) {
  const colsCls = columns === 2 ? "lg:grid-cols-2" : "lg:grid-cols-3";
  return (
    <div className={`grid gap-5 sm:grid-cols-2 ${colsCls}`}>
      {services.map((s) => (
        <article key={s.title} className="card-atk flex flex-col">
          <div className="flex items-start justify-between gap-3">
            <span className="badge-pill">{s.badge}</span>
            <span className="icon-circle"><s.icon className="h-5 w-5" /></span>
          </div>
          <h3 className="mt-6 text-[20px] font-bold text-navy">{s.title}</h3>
          <p className="mt-2 text-[15px] text-muted-foreground leading-relaxed flex-1">{s.body}</p>
          <p className="mt-5 text-[14px] text-navy font-semibold">{s.price}</p>
          <Link to={s.cta.to} className="mt-4 text-cta">
            {s.cta.label} <ArrowRight className="h-4 w-4" />
          </Link>
        </article>
      ))}
    </div>
  );
}
